import React, { useState } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import clsx from "clsx";
import * as Yup from "yup";
import { Formik } from "formik";
import { useSnackbar } from "notistack";

import {
  Autocomplete,
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,  
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { updateOrderStatus } from "src/actions/orderActions";


const useStyles = makeStyles(() => ({
  root: {},
  editor: {
    "& .ql-editor": {
      height: 400,
    },
  },
}));

const PAYMENT_TYPES = [
  { id: "ONLINE", label: "Online" },
  { id: "OFFLINE", label: "Offline" },
]


function UpdatePayment({ customerId, orderId, action, className, ...rest }) {
  const classes = useStyles();

  const account = useSelector((state) => state.account);

  const addedBy = account.user.email;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  return (

    <Formik
      initialValues={{
        customerId: customerId,
        orderId: orderId,
        status: "PAID",
        paymentType: "",
        reference: ""
      }}
      validationSchema={Yup.object().shape({
        // paymentType: Yup.string().max(20).required("Select Payment Type"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          await dispatch(updateOrderStatus(action, addedBy, values));
          setStatus({ success: true });
          setSubmitting(false);
          enqueueSnackbar("Payment Status Update Successfully", {
            variant: "success",
          });
          navigate("/app/management/order/search");

        } catch (err) {
          setErrors({ submit: err.message });
          setStatus({ success: false });
          setSubmitting(false);
          enqueueSnackbar("Failed to Update Payment Status", {
            variant: "failure",
          });
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form
          onSubmit={handleSubmit}
          className={clsx(classes.root, className)}
          {...rest}
        >
          <Grid container spacing={3} padding={2}>
            <Grid item xs={12}>
              <Typography>Capture Order Payment</Typography>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id="paymentType"
                name="paymentType"
                options={PAYMENT_TYPES}
                getOptionLabel={(option) => option.label}
                fullWidth
                // value={values.paymentType}
                value={PAYMENT_TYPES.find((option) => option.id === values.paymentType) || null}
                onChange={(event, newValue) => setFieldValue("paymentType", newValue?.id || "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Payment Type"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                error={Boolean(
                  touched.reference && errors.reference
                )}
                fullWidth
                helperText={
                  touched.reference && errors.reference
                }
                label="Reference Details"
                name="reference"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.reference}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} >

            {errors.submit && (
            <Box mt={3} >
              <FormHelperText error>{errors.submit}</FormHelperText>
            </Box>
          )}
          <Box mt={2} >
            <Button
              color="secondary"
              variant="contained"
              type="submit"
              disabled={isSubmitting}
              style={{ marginBottom: '5em' }}
            >
              Confirm Payment
            </Button>
            <Button style={{ marginLeft: '1em', marginBottom: '5em' }}
              color="secondary" variant='contained'
              component={RouterLink}
              to="/app/management/order/search"
            >
              Cancel
            </Button>
          </Box>
          </Grid>

          </Grid>

          
        </form>
      )}
    </Formik>
  );
}

UpdatePayment.propTypes = {
  className: PropTypes.string,
  customerId: PropTypes.number,
  orderId: PropTypes.number,    
};

export default UpdatePayment;